import TranslationsMain from "../../main/modules/Translations/pages/TranslationsMain";

const translationsLayoutRoutes = [
    {
        path: "",
        name: "TranslationsMain",
        component: TranslationsMain,
        meta: {
            isAuth: true,
            module: "translations",
            submodule: ""
        }
    },
    {
        path: "clients",
        name: "TranslationsMain",
        component: TranslationsMain,
        meta: {
            isAuth: true,
            module: "translations",
            submodule: ""
        }
    },
    {
        path: "employees",
        name: "TranslationsMain",
        component: TranslationsMain,
        meta: {
            isAuth: true,
            module: "translations",
            submodule: ""
        }
    },
    {
        path: "projects",
        name: "TranslationsMain",
        component: TranslationsMain,
        meta: {
            isAuth: true,
            module: "translations",
            submodule: ""
        }
    },
    {
        path: "invoices",
        name: "TranslationsMain",
        component: TranslationsMain,
        meta: {
            isAuth: true,
            module: "translations",
            submodule: ""
        }
    },
    {
        path: "offers",
        name: "TranslationsMain",
        component: TranslationsMain,
        meta: {
            isAuth: true,
            module: "translations",
            submodule: ""
        }
    },
    {
        path: "users",
        name: "TranslationsMain",
        component: TranslationsMain,
        meta: {
            isAuth: true,
            module: "translations",
            submodule: ""
        }
    },
    {
        path: "user",
        name: "TranslationsMain",
        component: TranslationsMain,
        meta: {
            isAuth: true,
            module: "translations",
            submodule: ""
        }
    },
    {
        path: "companies",
        name: "TranslationsMain",
        component: TranslationsMain,
        meta: {
            isAuth: true,
            module: "translations",
            submodule: ""
        }
    },
    {
        path: "subscriptions",
        name: "TranslationsMain",
        component: TranslationsMain,
        meta: {
            isAuth: true,
            module: "translations",
            submodule: ""
        }
    },
    {
        path: "sidebar",
        name: "TranslationsMain",
        component: TranslationsMain,
        meta: {
            isAuth: true,
            module: "translations",
            submodule: ""
        }
    },
    {
        path: "attributes",
        name: "TranslationsMain",
        component: TranslationsMain,
        meta: {
            isAuth: true,
            module: "translations",
            submodule: ""
        }
    },
    {
        path: "validation",
        name: "TranslationsMain",
        component: TranslationsMain,
        meta: {
            isAuth: true,
            module: "translations",
            submodule: ""
        }
    },
    {
        path: "enumTypes",
        name: "TranslationsMain",
        component: TranslationsMain,
        meta: {
            isAuth: true,
            module: "translations",
            submodule: ""
        }
    },

]

export default translationsLayoutRoutes;